import React from 'react';
import { cn } from '../lib/utils';
import OfficeChoiceButton from './office/OfficeChoiceButton';
import { planHasContentChoice } from '../lib/planContentProfile';

/**
 * Escolha Familiar / Adulto incluso — só aparece se o plano tiver content_choice_enabled.
 */
export default function ContentModePicker({
  plan,
  value = 'family',
  onChange,
  disabled = false,
  className,
  label = 'Conteúdo do pacote',
}) {
  if (!planHasContentChoice(plan)) return null;
  const mode = value === 'adult' ? 'adult' : 'family';

  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
        {label}
      </p>
      <div className="grid grid-cols-2 gap-2">
        <OfficeChoiceButton
          active={mode === 'family'}
          disabled={disabled}
          onClick={() => onChange?.('family')}
          className="!flex h-auto min-h-[3.25rem] flex-col items-start justify-center gap-0.5 px-3 py-2 text-left text-sm"
        >
          <span className="leading-tight">🛡️ Familiar</span>
          <span className="text-[10px] font-normal leading-snug opacity-75">
            Sem conteúdo +18
          </span>
        </OfficeChoiceButton>
        <OfficeChoiceButton
          active={mode === 'adult'}
          disabled={disabled}
          onClick={() => onChange?.('adult')}
          className="!flex h-auto min-h-[3.25rem] flex-col items-start justify-center gap-0.5 px-3 py-2 text-left text-sm"
        >
          <span className="leading-tight">🔞 Adulto incluso</span>
          <span className="text-[10px] font-normal leading-snug opacity-75">
            Com canais +18
          </span>
        </OfficeChoiceButton>
      </div>
    </div>
  );
}
